// src/components/AppButton.js
import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';


const colorMap = {
  primary: {
    borderColor: 'purple',
    color: 'white',
    backgroundColor: '#7C0BCC',    
  
    '&:hover': {
      borderColor: 'purple',
      backgroundColor: '#7c0bccff',    
    },
  },
  secondary: {
    borderColor: 'red',
    color: 'black',
    backgroundColor: '#ceccccee',    

    '&:hover': {
      borderColor: 'red',
      backgroundColor: '#ceccccee',
    },
  },
  tertiary: {
    borderColor: 'red',
    color: 'white',
     backgroundColor: '#e20e0eff', 
    '&:hover': {
      borderColor: 'red',
      backgroundColor: 'e20e0eff',
    },
  },
};

const AppButton = ({
  title,
  color = 'primary',
  variant = 'contained',
  onClick,
  size = 'medium',
  width,
  height,
  startIcon,   // <-- add this line
  endIcon,   
  children,
  sx = {},
  ...props
}) => {
  const customStyles = colorMap[color] || {};

  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
     sx={{
        width,
        height,
        fontFamily: '"Poppins", sans-serif',
        textTransform: 'none',
        borderRadius: '4px',
        boxShadow:'none',
        ...customStyles,
        ...sx,
      }}
      {...props}
    >
     {children}
    </Button>
  );
};

export default AppButton;
